import React from 'react'
import styled from '@emotion/styled'
import { SizeMods } from 'components/styles/primitives/modifiers/size'
import { RibbonBackgroundTheme } from '../../../patterns/themes/styles/backgrounds'
import { TextColorTheme } from '../../../patterns/themes/styles/text'
import { Card } from '../Card'
import { Box } from '../../../layout/primitives'

export const Ribbon: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
	<Card.Header>
		<RibbonStyles>{children}</RibbonStyles>
	</Card.Header>
)

const RibbonStyles = styled(Box)`
	${SizeMods.FullWidth};
	${RibbonBackgroundTheme};
	${TextColorTheme};
`
